module.exports = __webpack_public_path__ + "media/images/icons/error-808a647173d6480b71ccc511447b2521.svg";